import { dom, library } from '@fortawesome/fontawesome-svg-core'; // import {
// 	faFacebookF,
// 	faTwitter,
// 	faInstagram,
// 	faYoutube,
// 	faLinkedinIn
// } from '@fortawesome/free-brands-svg-icons'
// 
// import {
// 	faAngleLeft,
// 	faAngleRight,
// 	faSearch,
// } from '@fortawesome/pro-light-svg-icons'
// import {
// 	faAngleDown,
// } from '@fortawesome/pro-regular-svg-icons'
// import {
// 	faBars,
// 	faTimes,
// } from '@fortawesome/pro-solid-svg-icons'
// import {} from '@fortawesome/pro-duotone-svg-icons'
// NOTE
// FOR DEV ONLY
// THIS IS ALOT

import { fab } from '@fortawesome/free-brands-svg-icons';
import { fas } from '@fortawesome/pro-solid-svg-icons';
import { far } from '@fortawesome/pro-regular-svg-icons';
import { fal } from '@fortawesome/pro-light-svg-icons';
import { fad } from '@fortawesome/pro-duotone-svg-icons';
library.add(fab, fas, far, fal, fad // // brands
// faFacebookF,
// faTwitter,
// faInstagram,
// faYoutube,
// faLinkedinIn,
// // light
// faAngleLeft,
// faAngleRight,
// faSearch,
// // regular
// faAngleDown,
// // solid
// faBars,
// faTimes,
// // duotone
);
dom.watch();